export const EDUCATIONS = [
  {
    icon: "LaptopRegular",
    title: "Scaler School of Technology",
    degree: "Undergraduate Program in Software Development",
    grade: "Batch of 2023 - 2027, 9.17 CGR",
  },
  {
    icon: "GraduationCapRegular",
    title: "Birla Institute of Technology and Science, Pilani",
    degree: "BSc Hons in Computer Science",
    grade: "Batch of 2023 - 2027, 7.62 CGPA",
  },
  {
    icon: "BookRegular",
    title: "Aravali International School",
    degree: "CBSE Boards - Class 12th",
    grade: "Batch of 2022 - 2023, 91.2%",
  },
  {
    icon: "BookRegular",
    title: "Aravali International School",
    degree: "CBSE Boards - Class 10th",
    grade: "Batch of 2020 - 2021, 92.7%",
  },
];

